import { render } from "./AddInvitationView.vue?vue&type=template&id=71a6f492&scoped=true"
import script from "./AddInvitationView.vue?vue&type=script&lang=js"
export * from "./AddInvitationView.vue?vue&type=script&lang=js"

import "./AddInvitationView.vue?vue&type=style&index=0&id=71a6f492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a6f492"]])

export default __exports__